export default __webpack_public_path__ + "static/media/FourPartIllustration.ba3b1669.png";